import React, { FC, useMemo } from 'react'
import { withFont } from 'assets/sharedStyles'
import { Field } from 'react-final-form'
import { AtlasSelectAdapter } from 'components/atlas-material/select'
import { linkedBookStructureMenuItems } from 'components/popovers/linked-book-structure/linked-book-structure-items'
import { pendoTrack } from 'common/util/functions'
import styled from '@emotion/styled'
import i18n from 'i18next'

type Props = {
    bookTitle: string | number | null | undefined
}

export const BookStructureField: FC<Props> = ({ bookTitle }) => {
    const memoLinkedBookStructureMenuItems = useMemo(() => linkedBookStructureMenuItems(), [])

    return (
        <>
            <div style={{ width: '50%', paddingRight: '5px' }}>
                <Field
                    name="bookStructure"
                    showErrorWhen={true}
                    render={(fieldProps) => (
                        <AtlasSelectAdapter
                            {...fieldProps}
                            label={i18n.t('IMPORT_TYPE')}
                            data-testid="MinutesProperties_BookStructure"
                            onChange={(event) => {
                                const value = event?.target?.value
                                if (value === 'TOP_LEVEL') {
                                    pendoTrack('LinkedBookStructureSelect_Option', {
                                        interaction: 'change',
                                        source: 'book-structure-field',
                                        domEvent: 'change',
                                        bookStructure: value
                                    })
                                }
                                fieldProps.input.onChange(event)
                            }}>
                            {memoLinkedBookStructureMenuItems}
                        </AtlasSelectAdapter>
                    )}
                />
            </div>
            <BookStructureText>{i18n.t('BOOK_STRUCTURE_LABEL', { bookTitle })}</BookStructureText>
        </>
    )
}

const BookStructureText = withFont('text-medium-grey')(styled.div`
    margin-left: 24px;
`)
